class ProductForm extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.form = this.querySelector('form');
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.Cart = document.querySelector('w3-cart');
        this.submitButton = this.querySelector('[type="submit"]');

        // Sometimes, the user arrive to the product page with a product that need to be customized.
        // We check if the product is customizable and if the user has already set a customization.
        // This check is only done if the component is in the product page. (@todo: find a better way to do this)
        if(this.closest('#product.product')) {
            this.updateSubmitButtonStateDependingOnCustomization();
        }
    }

    updateSubmitButtonStateDependingOnCustomization() {
        const needCustomErrorMessageElement = document.querySelector('.js-error-need-customization')

        // Check if the product section is marked as customizable
        const productIsCustom = document.querySelector('section.product.product--is-customization');

        // Also check if the product form has customization
        const productFormHasCustomizationText = document.querySelectorAll('input[class*="js-property-text"]').length > 0 && [...document.querySelectorAll('input[class*="js-property-text"]')].every((input) => typeof input !== 'undefined' && input.value !== '');

        const productFormHasCustomizationIcon = document.querySelectorAll('input[class*="js-property-icon"]').length > 0 && [...document.querySelectorAll('input[class*="js-property-icon"]')].every((input) => typeof input !== 'undefined' && input.value !== '');

        // If the product is customizable but the form has no customization, we disable the submit button.
        // User must set a customization before adding to cart.
        if (productIsCustom && (!productFormHasCustomizationText && !productFormHasCustomizationIcon)) {

                setTimeout(() => {
                    const mainButton = document.querySelector('.product__info-wrapper #product-add-to-cart');
                    mainButton?.setAttribute('aria-disabled', true);
                    mainButton?.setAttribute('disabled', true);

                    const stickyButton = document.querySelector('.product-sticky-buybox__form .button--add-to-cart');
                    stickyButton?.setAttribute('aria-disabled', true);
                    stickyButton?.setAttribute('disabled', true);
                }, 150);

                if (needCustomErrorMessageElement) {
                    needCustomErrorMessageElement.style.display = "block";
                }

        } else {
            setTimeout(() => {
                const mainButton = document.querySelector('.product__info-wrapper #product-add-to-cart');
                mainButton?.removeAttribute('aria-disabled');
                mainButton?.removeAttribute('disabled');

                const stickyButton = document.querySelector('.product-sticky-buybox__form .button--add-to-cart');
                stickyButton?.removeAttribute('aria-disabled');
                stickyButton?.removeAttribute('disabled');
            }, 150);

            if (needCustomErrorMessageElement) {
                needCustomErrorMessageElement.style.display = "none";
            }
        }

    }

    onSubmitHandler(e) {
        e.preventDefault();

        const inDrawer = e.currentTarget.closest('.js-drawer');

        if(!inDrawer) {
            // Validate the form if the product is customized
            // If the product has custom variant, we should check if the user has set a customization before adding to cart.
            const hasCustomOptionChecked = document.querySelector('input[value$="(custom)"]:checked');
            const customTextProperties = document.querySelector('input[class*="js-property-text"]');
            const customIconProperties = document.querySelector('input[class*="js-property-icon"]');

            const emptyTextProperties = customTextProperties?.length <= 0 || // element not exist
                customTextProperties?.disabled || // element is disabled
                customTextProperties?.value === "" || // value is empty
                customTextProperties?.value === null || // value is null
                !customTextProperties?.value.replace(/\s/g, '').length; // value is only whitespace (or empty string)

            const emptyIconProperties = customIconProperties?.length <= 0 || // element not exist
                customIconProperties?.disabled || // element is disabled
                customIconProperties?.value === "" || // value is empty
                customIconProperties?.value === null || // value is null
                !customIconProperties?.value.replace(/\s/g, '').length; // value is only whitespace (or empty string)

            if(hasCustomOptionChecked && (emptyTextProperties && emptyIconProperties)) {
                console.error('Fatal Error : Product has custom option checked but no customization set.');
                return;
            }

            if(!hasCustomOptionChecked && (!emptyTextProperties && !emptyIconProperties)) {
                console.error('Fatal Error : Product has text customization but not attached to a variant.');
                return;
            }
        }

        if (this.submitButton.classList.contains('button--loading')) return;

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('button--loading');

        const config = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': `application/javascript` }
        };
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        if (this.Cart) {
            formData.append('sections', this.Cart.getSectionsToRender().map((section) => section.id));
            formData.append('sections_url', window.location.pathname);
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
                if (response.status) {
                    this.handleErrorMessage(response.description);
                    return;
                }

                if (this.Cart) {
                    this.Cart.updateCart(response);
                }

                const cartDrawerUpdateEvent = new CustomEvent('theme:drawer:cart:update');
                document.dispatchEvent(cartDrawerUpdateEvent);

                const cartDrawerEvent = new CustomEvent('theme:drawer:cart:open');
                document.dispatchEvent(cartDrawerEvent);
            })
            .finally(() => {
                this.submitButton.classList.remove('button--loading');
                this.submitButton.removeAttribute('aria-disabled');
            })
            .catch((e) => {
                console.error(e);
            });
    }

    handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper = this.querySelector('.product-form__error-message-wrapper');
        this.errorMessage = this.errorMessageWrapper.querySelector('.product-form__error-message');
        this.errorMessageWrapper.hidden = !errorMessage;

        if (errorMessage) {
            this.errorMessage.textContent = errorMessage;
        }
    }
}

customElements.define('product-form', ProductForm);
